import React, {
  createContext,
  useReducer,
  useEffect,
  useContext,
  useMemo,
} from 'react';

import { LicenseInfo } from '@mui/x-license';

import Reducer from './AppReducer';
import { initialState } from './index';
import { AppState } from '../@types/State';
export const STORAGE_KEY = 'AppState';

LicenseInfo.setLicenseKey(
  '152db89b745eed231f30fd497b992665Tz0xMDY3MzgsRT0xNzY5NTU4Mzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
);

export const parseState = (str: string | null) => {
  return (str ? JSON.parse(str) : {}) as AppState;
};

const persistedState: AppState = {
  ...initialState,
  ...parseState(localStorage.getItem(STORAGE_KEY)),
};

const AppContext = createContext<{
  appState: AppState;
  appDispatch: React.Dispatch<any>;
}>({
  appState: persistedState,
  appDispatch: () => null,
});

interface Props {
  children: React.ReactNode;
}

const AppProvider: React.FC<Props> = ({ children }) => {
  const [appState, appDispatch] = useReducer(Reducer, persistedState);
  const obj = useMemo(() => ({ appState, appDispatch }), [appState]);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(appState));
  }, [appState]);
  return <AppContext.Provider value={obj}>{children}</AppContext.Provider>;
};

export function useAppState() {
  return useContext(AppContext);
}

export { AppContext, AppProvider };
